import axios from 'axios'

const http = axios.create({
  baseURL: import.meta.env.VITE_REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

http.interceptors.response.use(
  (config) => {
    const user = localStorage.getItem('cognito:user')
    const token = user ? JSON.parse(user)?.token : null
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    // if (error.code === 'ERR_NETWORK' || error.response.status === 401) {
    //   localStorage.clear()
    //   window.location.href = '/login'
    // }
    return Promise.reject(error)
  }
)

export { http, axios }
